/**
 * Admin Dashboard Hooks
 */

import { useQuery } from '@tanstack/react-query'
import { tokenStorage } from '@/lib/api'
import * as service from './admin-dashboard.service'

const adminDashboardKeys = {
  all: ['admin-dashboard'] as const,
  businessKpis: () => [...adminDashboardKeys.all, 'business-kpis'] as const,
  recentActivity: () => [...adminDashboardKeys.all, 'recent-activity'] as const,
  institutionsSummary: () => [...adminDashboardKeys.all, 'institutions-summary'] as const,
}

export function useBusinessKpis() {
  const hasToken = !!tokenStorage.getAccessToken()

  return useQuery({
    queryKey: adminDashboardKeys.businessKpis(),
    queryFn: service.getBusinessKpis,
    enabled: hasToken,
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000, // refresca cada minuto
  })
}

export function useRecentActivity() {
  const hasToken = !!tokenStorage.getAccessToken()

  return useQuery({
    queryKey: adminDashboardKeys.recentActivity(),
    queryFn: service.getRecentActivity,
    enabled: hasToken,
    staleTime: 30 * 1000,
  })
}

export function useInstitutionsSummary() {
  const hasToken = !!tokenStorage.getAccessToken()

  return useQuery({
    queryKey: adminDashboardKeys.institutionsSummary(),
    queryFn: service.getInstitutionsSummary,
    enabled: hasToken,
    staleTime: 30 * 1000,
  })
}
